import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ColumnDescription } from "react-bootstrap-table-next";
import Swal from "sweetalert2";
import { DeletarMotivoProblemaController } from "../../../../../../Controllers/AssistenciaTecnica/MotivoProblema/MotivoProblemasControllers";
import { IMotivoProblema } from "../../../../../../Interfaces/AssistenciaTecnica/MotivoProblema/MotivoProblemaInterfaces";
import Table from "../../../../../Table";
import OrSpinner from "../../../../../Utils/OrSpinner";

interface IListagemMotivoProblemaProps {
    listarMotivosProblema: Array<IMotivoProblema>;
    setEdit: (tpa: IMotivoProblema) => void;
    updateLstMotivoProblema: () => void;
    listarMotivosProblemaLoading: boolean;
}

export default function ListagemMotivoProblema(
    props: IListagemMotivoProblemaProps
) {
    const columns: Array<ColumnDescription<IMotivoProblema>> = [
        {
            dataField: "DS_MOTIVO_PROBLEMA",
            text: "Descrição",
            formatter: rowMotivoProblema,
            sort: true,
        },
        {
            dataField: "ID_MOTIVO_PROBLEMA_PAI",
            text: "Motivo Problema Pai",
            formatter: rowMotivoProblemaPai,
            sort: true,
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "FL_ATIVO",
            text: "Ativo",
            formatter: rowFlAtivo,
            sort: true,
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "button",
            text: "Editar",
            align: "center",
            headerAlign: "center",
            formatExtraData: props.setEdit,
            formatter: (c, row, _, setEdit) => (
                <div className="">
                    <button
                        className="btn btn-icon btn-outline-primary"
                        onClick={() => {
                            setEdit(row);
                        }}
                    >
                        <FontAwesomeIcon icon={faEdit} size="lg" />
                    </button>
                </div>
            ),
        },
        {
            dataField: "button",
            text: "Deletar",
            align: "center",
            headerAlign: "center",
            isDummyField: true,
            formatter: (_, row) => (
                <div className="">
                    <div>
                        {
                            <button
                                className="btn btn-sm btn-outline-danger font-weight-bold"
                                onClick={() => {
                                    Swal.fire({
                                        title: "Deseja apagar este Motivo Problema?",
                                        icon: "info",
                                        buttonsStyling: false,
                                        confirmButtonText:
                                            "<i class='la la-check'></i> Sim!",
                                        showCancelButton: true,
                                        cancelButtonText:
                                            "<i class='la la-thumbs-down'></i> Não",
                                        customClass: {
                                            confirmButton:
                                                "btn btn-outline-success",
                                            cancelButton: "btn btn-default",
                                        },
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            DeletarMotivoProblemaController(
                                                row.ID_MOTIVO_PROBLEMA
                                            ).then(() => {
                                                props.updateLstMotivoProblema();
                                            });
                                        }
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faTrash} size="lg" />
                            </button>
                        }
                    </div>
                </div>
            ),
        },
    ];

    function rowMotivoProblema(cell: string, row: IMotivoProblema) {
        return (
            <div className="rowCapys">
                <div>
                    <label className="mb-1">{row.DS_MOTIVO_PROBLEMA}</label>

                    <div>
                        {row.DS_MOTIVO_PROBLEMA && (
                            <>
                                <span
                                    className={`label abel-pill label-inline label-primary`}
                                >
                                    {row.ID_MOTIVO_PROBLEMA} {"-"}{" "}
                                    {row.DS_MOTIVO_PROBLEMA}
                                </span>
                            </>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    function rowMotivoProblemaPai(cell: string, row: IMotivoProblema) {
        return (
            <div>
                <label className="mb-1">{row.ID_MOTIVO_PROBLEMA_PAI}</label>
            </div>
        );
    }

    function rowFlAtivo(cell: string, row: IMotivoProblema) {
        return (
            <div>
                <label className="mb-1">
                    {row.FL_ATIVO === true ? "Sim" : "Não"}
                </label>
            </div>
        );
    }

    return (
        <>
            <div className="col-12 mt-5">
                <OrSpinner
                    loading={props.listarMotivosProblemaLoading}
                    spinner="capys"
                >
                    <Table
                        keyField="ID_MOTIVO_COMPRA"
                        columns={columns}
                        data={props.listarMotivosProblema ?? []}
                        sizePerPage={10}
                        loading={props.listarMotivosProblemaLoading}
                        noDataIndication={
                            <div className="text-center text-muted">
                                Nenhum Motivo Compra
                            </div>
                        }
                        wrapperClasses="wrapperTable mw-100 x-scroll"
                        classes="tableClasses"
                        bordered={false}
                        center
                    />
                </OrSpinner>
            </div>
        </>
    );
}
